import { Component, ElementRef, HostListener, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { UrlService } from '../../services/url.service';
import { AmenitiesService } from '../../services/amenities.service';
import { ApiClientService } from '../../services/api-client.service';
import { SettingsAmenitiesService } from '../../services/settings-amenities.service';
import { AuthenticationService } from '../../services/authentication.service';

declare const toastr: any;

@Component({
    selector: 'maintenance-calendar-filter',
    templateUrl: './maintenance-calendar-filter.component.html',
    styleUrls: ['./maintenance-calendar-filter.component.scss']
})
export class MaintenanceCalendarFilterComponent implements OnInit {
    showDropdown = false;

    @ViewChild('approvedCheckbox') approved: ElementRef;
    @ViewChild('pendingCheckbox')  pending:  ElementRef;
    @ViewChild('expiredCheckbox')  expired:  ElementRef;
    @ViewChild('declinedCheckbox') declined: ElementRef;
    constructor(private urlService: UrlService,
        public amenitiesService: AmenitiesService,
        public settingsAmenitiesService: SettingsAmenitiesService,
        public api: ApiClientService,
        public authenticationService: AuthenticationService,
    ) { }

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(_ => {
            const status = this.urlService.queryParams['status'];
            if (status) {
                this.approved.nativeElement.checked = status.indexOf('approved') !== -1;
                this.pending.nativeElement.checked = status.indexOf('pending') !== -1;
                this.expired.nativeElement.checked = status.indexOf('expired') !== -1;
                this.declined.nativeElement.checked = status.indexOf('declined') !== -1;
            } else {
                this.approved.nativeElement.checked = false;
                this.pending.nativeElement.checked = false;
                this.expired.nativeElement.checked = false;
                this.declined.nativeElement.checked = false;
            }
        });
    }

    changeFilter() {
        const approvedValue = this.approved.nativeElement.checked;
        const pendingValue = this.pending.nativeElement.checked;
        const expiredValue = this.expired.nativeElement.checked;
        const declinedValue = this.declined.nativeElement.checked;

        if (!approvedValue && !pendingValue && !expiredValue && !declinedValue) {
            this.urlService.queryParams['status'] = null;
        } else {
            let status = '';
            if (approvedValue) status += 'approved,';
            if (pendingValue) status += 'pending,';
            if (expiredValue) status += 'expired,';
            if (declinedValue) status += 'declined,';
            this.urlService.queryParams['status'] = status.slice(0, -1);
        }
        this.urlService.setQueryParams(null, 1);
        this.amenitiesService.getData();
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('maintenance-calendar-filter')) this.showDropdown = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/maintenance-calendar-filter/maintenance-calendar-filter.component.ts